module.exports = __webpack_public_path__ + "static/media/icon-phone.c9ea2e93.svg";